var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({staticClass:"rating-badge",class:[
    _vm.classname,
    { condensed: _vm.condensed, loved: _vm.loved, liked: _vm.liked, 'not-liked': _vm.notLiked, opaque: _vm.opaque },
  ]},_vm.$listeners),[(_vm.icon)?_c('AppIcon',{attrs:{"src":_vm.icon}}):_vm._e(),(_vm.$slots.default)?_vm._t("default"):(_vm.label)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }